export default "__VITE_ASSET__Dgk3Zt$4__"